import { CharterFareInventory } from '~/components/Flights/Charter/charter.types';

import * as TimeService from '~/services/TimeService';

type Option<Value> = { label: string; value: Value };

export const stayOptions: Array<Option<number>> = [
  { label: '5 nights', value: 5 },
  { label: '12 nights', value: 12 },
];

export const cabinOptions: Array<Option<CharterFareInventory['cabinClass']>> = [
  { label: 'Business', value: 'BUSINESS' },
  { label: 'SkyLounge', value: 'LUX_ROW' },
  { label: 'Premium Economy', value: 'PREMIUM_ECONOMY' },
  { label: 'Economy', value: 'ECONOMY' },
];

export const monthOptions: Array<Option<number>> = TimeService.getMonths().map((label, index) => ({
  label,
  value: index + 1,
}));

export const defaultMonths = monthOptions.map((option) => option.value);

export const pageSizeOptions = [10, 20, 50, 100];

const csvHeaders = [
  'Direction',
  'Departure Date',
  'Departure Time',
  'Arrival Date',
  'Arrival Time',
  'Departure Airport Code',
  'Arrival Airport Code',
  'Cabin Class',
  'Booking Class',
  'Total Bookable Seats',
  'Sold Seats',
  'Total Blocked Seats',
  'Available Seats',
  'Currency',
  'Seat Price (Adult)',
  'Seat Price (Child)',
  'Seat Price (Infant)',
  'Tax (Adult)',
  'Tax (Child)',
  'Tax (Infant)',
  'Blocked Seats (VVIP)',
  'Blocked Seats (Crew Rest)',
  'Blocked Seats (Dummy)',
  'Passenger Count (Adult)',
  'Passenger Count (Child)',
  'Passenger Count (Infant)',
] as const;
export type CharterInventoryCsvHeader = (typeof charterInventoryCsvHeaders)[number];
export const charterInventoryCsvHeaders = [...csvHeaders];

const excludedColumns: ReadonlySet<CharterInventoryCsvHeader> = new Set(['Tax (Adult)', 'Tax (Child)', 'Tax (Infant)']);

export const defaultSelectedColumns: Array<CharterInventoryCsvHeader> = charterInventoryCsvHeaders.filter(
  (col) => !excludedColumns.has(col),
);
